'use client';

import { Button } from '@common/components';
import { cn } from '@core/utils';

import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { DONATION_ROUTES, WELLO_IMAGE_PREFIX_URL } from '@/constants';

import styles from './SnsEventSection.module.scss';

export const SnsEventSection = () => {
  return (
    <section
      id="sns-event"
      className="flex w-full scroll-mt-46 flex-col items-center gap-32 overflow-hidden bg-R-600 px-32 py-60"
    >
      <div className="rounded-xxlarge bg-[#f6e0cf] px-20 py-6">
        <p className="text-center font-700 text-R-600 typo-body1">Event 5</p>
      </div>

      <div className="flex flex-col items-center gap-8 text-center">
        <p className="font-700 text-[#f6e0cf] typo-h7">
          답례품이 만족스러우셨다면,
        </p>
        <h2 className="font-800 text-[#f6e0cf] typo-h4">
          블로그/인스타그램에
          <br />
          기부 경험을 공유해주세요!
        </h2>
      </div>

      <div
        className={cn(
          'relative h-280 w-[500px] max-w-none',
          styles.bounceIn,
        )}
      >
        <Image
          src={`${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market/sns-hero.png`}
          alt="SNS 이벤트"
          fill
          className="object-contain"
        />
        <div
          className={cn(
            'absolute left-[34%] top-[12%] size-100',
            styles.float1,
          )}
        >
          <Image
            src={`${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market/blog.png`}
            alt="블로그"
            fill
            className="object-contain"
          />
        </div>
        <div
          className={cn(
            'absolute right-[34%] top-2/5 size-120',
            styles.float2,
          )}
        >
          <Image
            src={`${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market/insta.png`}
            alt="인스타그램"
            fill
            className="object-contain"
          />
        </div>
      </div>

      <div className="z-[1] -mt-60 w-full max-w-[375px]">
        <Button className="w-full" asChild>
          <CustomLink href={DONATION_ROUTES.SNS_MARKET.pathname}>
            이벤트 자세히 보기
          </CustomLink>
        </Button>
      </div>
    </section>
  );
};
